export default __webpack_public_path__ + "static/media/09.61d76111.jpg";